function NewGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}

function emptyGuid() {
    return '00000000-0000-0000-0000-000000000000';
}

function convertTimePartsIntoTime(hour, minutes, amPmDesignator) {
    if (amPmDesignator == "PM") {
        hour += 12;
    }
    return hour + ":" + minutes;
}

function getRgbaColor(color) {
    if (color == undefined) {
        return "rgb(0,0,0)";
    }
    return "rgba(" + color[0] + "," + color[1] + "," + color[2] + "," + color[3] + ")";
}

function replaceAll(str, find, replace) {
    return str.replace(new RegExp(find, 'g'), replace);
}

function isObject(obj) {
    return obj === Object(obj);
}

function getHashValue(key) {
    var matches = location.hash.match(new RegExp(key + '=([^&]*)'));
    return matches ? matches[1] : null;
}